import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { baseQueryWithReauth } from 'shared/store';

export const bannerApi = createApi({
  reducerPath: 'bannerApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['BannerId', 'Banners'],
  endpoints: () => ({}),
});
